// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field[data-v-021ea6b9]{border-radius:5px}.custom-account[data-v-021ea6b9]{width:100%}.custom-account .account-content[data-v-021ea6b9]{align-content:center;align-items:center;align-self:center;justify-content:center;justify-items:center;margin-top:7%}@media screen and (max-width:800px){.custom-account .account-content[data-v-021ea6b9]{margin-top:50%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
